"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
function TextField(props) {
    const { register, formState, watch } = (0, react_hook_form_1.useFormContext)();
    const { ref, onChange } = register(props.name);
    const { errors } = formState;
    const value = watch(props.name);
    return (react_1.default.createElement(material_1.FormControl, { fullWidth: props.fullWidth, error: !!errors[props.name] },
        react_1.default.createElement(material_1.TextField, { variant: props.variant || "standard", multiline: props.multiline, label: props.label, inputRef: ref, InputLabelProps: {
                shrink: !!value,
            }, error: !!errors[props.name], onChange: (event) => onChange({
                target: {
                    name: props.name,
                    value: event.target.value,
                },
            }), inputProps: {
                "aria-label": props.label,
            } }),
        !!errors[props.name] && (react_1.default.createElement(material_1.FormHelperText, null, errors[props.name].message)),
        !!props.helpText && (react_1.default.createElement(material_1.FormHelperText, { focused: true }, props.helpText))));
}
exports.default = TextField;
